import { z } from "zod"
import { baseSchema, schemaToJson } from "../schema-utils.js"

const DbLogSchema = z.strictObject({
  ...baseSchema.shape,
  title: z.string(),
  status: z.enum(["Progress", "Success", "Failed", "Poke"]).nullable(),
  created_at: z.date(),
})
export type DbLog = z.infer<typeof DbLogSchema>

export const LogSchema = schemaToJson(DbLogSchema)
export type Log = z.infer<typeof LogSchema>
